import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { Contribution } from '../models/contribution.model';
import { IContributionApi } from './interfaces/contribution-abstract.api';

@Injectable({
  providedIn: 'root',
})
export class ExternalContributionApi implements IContributionApi {
  constructor(private readonly http: HttpClient) { }

  getContributionSummary(userId: number): Observable<Contribution> {
    const url = environment.api.externalUser.contributionSummary.replace('{userId}', '' + userId);
    return this.http.get<Contribution>(url);
  }
}
